import callApi from './personnelService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}`;

export const updateSubscription = (input) => callApi({
  method: 'POST',
  endpoint: `${basePath}/new-customer-subscription/subscription`,
  body: input,
  options: {
    skip: true //customize handle catch alert
  }
});
export const updateBackMember = (input) => callApi({
  method: 'POST',
  endpoint: `${basePath}/new-customer-subscription/subscription-for-back-member`,
  body: input,
  options: {
    skip: true //customize handle catch alert
  }
});
export const getMemberList = (input) => callApi({
  method: 'POST',
  endpoint: `${basePath}/new-customer-subscription/get-member-list`,
  body: input
});
export const getCanTakeList = (input) => callApi({
  method: 'POST',
  endpoint: `${basePath}/new-customer-subscription/get-can-take-sample-list`,
  body: input
});
export const getMemberProgramRecord = (memberId) => callApi({
  method: 'POST',
  endpoint: `${basePath}/member/get-member-new-customer-take-sample/${memberId}`,
});
export const removeNewMemberTag = (memberId) => callApi({
  method: 'POST',
  endpoint: `${basePath}/new-customer-subscription/remove-new-customer-tag/${memberId}`,
});
export const applyProgram = (input) => callApi({
  method: 'POST',
  endpoint: `${basePath}/member/add-take-sample-record/${input.memberId}`,
  body: input
});